export default __webpack_public_path__ + "static/media/MTcarpaEspecial_LateralDer.1b99bdd7.webp";